











































import {
  Vue,
  Component,
  Prop,
  Emit,
  Watch,
  Mixins
} from 'vue-property-decorator'
import ExtensionPromptModel from '@/models/investigation/promptModel.ts'
import { UrlType } from '../../constants/urlType'
import ExtensionModule from '../../store/extensionModule'
import { getModule } from 'vuex-module-decorators'
import apiService from '../../services/apiService'
import Validation from '@/mixins/validation.ts'

const extensionModule = getModule(ExtensionModule)

@Component
export default class AddPromptDialog extends Mixins(Validation) {
  @Prop(Boolean) dialog!: boolean
  @Prop(String) readonly title!: string
  @Prop(String) readonly stageKey!: string

  private valid: boolean = true

  private selected: string = ''

  private prompt: string = ''

  private categories: Array<string> = ['ESP', 'HB', 'ORG']

  @Emit()
  private save(): ExtensionPromptModel | null {
    const prompt = new ExtensionPromptModel()
    if (
      (this.$refs.form as Vue & {
        validate: () => boolean
      }).validate()
    ) {
      // Build model to be validated on post question
      prompt.promptCategory = this.selected
      prompt.prompt = this.prompt
      prompt.extensionId = extensionModule.getExtensionId

      return prompt
    }
    return null
  }

  @Watch('dialog')
  onDialogChanged() {
    if (!this.dialog) {
      const form: any = this.$refs.form
      form.reset()
    }
  }
}
